import { render } from "./addChampionship-step2.vue?vue&type=template&id=7b730de4"
import script from "./addChampionship-step2.vue?vue&type=script&lang=js"
export * from "./addChampionship-step2.vue?vue&type=script&lang=js"

import "./addChampionship-step2.vue?vue&type=style&index=0&id=7b730de4&lang=css"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__